import VerifiedIcon from '@streamlinehq/streamlinehq/img/streamline-regular/interface-essential/form-validation/check-badge.svg';
import { MetricNature } from '@upright/common/model/input/types';
import ModelledIcon from '@upright/ui/icons/img/streamline-mini-line/interface-essential/hierarchy/interface-hierarchy-3.svg';

export function getIconAndColorByNature(nature: MetricNature) {
  const color = nature === MetricNature.DIRECT_DISCLOSURE ? '#2188FF' : '#2F363D'; // Making an exception to reference customTheme
  switch (nature) {
    case MetricNature.DIRECT_DISCLOSURE:
    case MetricNature.THIRD_PARTY_ASSESSMENT:
      return { Icon: VerifiedIcon, color };
    case MetricNature.UPRIGHT_ESTIMATE:
    case MetricNature.UPRIGHT_MANUAL_ASSESSMENT:
    default:
      return { Icon: ModelledIcon, color };
  }
}
